import React from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { SHOP_TYPE } from 'common/config/enum'

export default (props) => {
  return <Select
    {...props}
    data={[{ label: '天猫', value: SHOP_TYPE.TMALL },
      { label: '淘宝', value: SHOP_TYPE.TAOBAO }]}
    placeholder="商品来源"
  />
}

export const NewShopType = ({ value, onChange }) => {
  return <div style={{
    display: 'flex',
    alignItems: 'center',
  }}
  >
    <div style={{ color: 'var(--m-text-1)' }}>商品来源：</div>
    <Select
      placeholder="不限"
      value={value}
      onChange={onChange}
      data={[{ label: '天猫', value: SHOP_TYPE.TMALL },
        { label: '淘宝', value: SHOP_TYPE.TAOBAO }]}
    />
  </div>
}
